import React from "react";

const AllBooking = () => {
  return (
    <div>
      <h1>this is AllBooking</h1>
    </div>
  );
};

export default AllBooking;
